function getuserInfoState(state) {
  return {
    name: state.user.info.name,
    premier: state.user.info.premier,
    urlLogo: state.user.info.urlLogo,
    lastName: state.user.info.lastName,
    email: state.user.info.email,
    phone: state.user.info.phone,
    isSeeker: state.user.info.isSeeker,
    isLoading: state.user.loading,
    fetchError: state.user.info.fetchPostingsError,
    userTypeId: state.user.info.userTypeId,
    publisherTypeId: state.user.info.publisherTypeId,
    publisherId: state.user.info.publisherId,
    isIntegrator: state.user.info.isIntegrator,
    lockedSoft: state.user.info.lockedSoft,
    lockedManual: state.user.info.lockedManual,
    isAssistant: state.user.info.isAssistant,
    fetched: state.user.fetched,
    isPublisherMasked: state.user.info.isPublisherMasked,
    maskChecked: state.user.info.maskChecked,
    isVAPublisher: state.user.info.isVAPublisher,
    hasAcceptedTermsAndconditions: state.user.info.hasAcceptedTermsAndconditions,
    fetchedAcceptTermsAndConditions: state.user.fetchedAcceptTermsAndConditions,
    errorAcceptTermsAndConditions: state.user.errorAcceptTermsAndConditions,
    appliesToI24Full: state.user.info.appliesToI24Full,
    showTasador: state.user.info.showTasador || null,
    hasConfirmedContactData: state.user.info.hasConfirmedContactData,
    userFromApp: state.user.userFromApp,
    showLogin: state.user.showLogin,
    userLoggedId: state.user.info.userLoggedId,
    realEstateName: state.user.info.realEstateName
  };
}

export { getuserInfoState };
